import type { ListBuilderConfiguration } from '../types';

/**
 * Warehouse list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const WAREHOUSE_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-warehouses-all',
			cacheTTL: 600000,
			name: 'All Warehouses',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'warehouse-name',
					fields: [
						{
							id: 'name-field',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'warehouse',
								idField: 'id',
							},
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'name',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-1',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'external-id-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'externalId',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h1',
							text: 'Name',
						},
					],
					minWidth: 175,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'name',
							objectTable: 'warehouse',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'location',
					fields: [
						{
							id: 'address1-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'address1',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-address',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'address2-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'address2',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-address2',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'city-state-zip',
							dataConfig: {
								type: 'template',
								template: '{warehouse.city}, {warehouse.state} {warehouse.zip}',
								templateFields: [],
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h2',
							text: 'Location',
						},
					],
					minWidth: 150,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'state',
							objectTable: 'warehouse',
						},
						{
							direction: 'ASC',
							fieldName: 'city',
							objectTable: 'warehouse',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'companies',
					fields: [
						{
							id: 'company-names',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'companyNames',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h3',
							text: 'Company',
						},
					],
					minWidth: 150,
					sortable: false,
					alignment: 'left',
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'clients-count',
					fields: [
						{
							id: 'clients-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'clientCount',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h4',
							text: 'Clients',
						},
					],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'clientCount',
							objectTable: 'warehouse',
						},
					],
					widthConfig: {
						mode: 'fixed',
						width: 100,
					},
					verticalAlignment: 'top',
				},
				{
					id: 'items-count',
					fields: [
						{
							id: 'items-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'itemCount',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h5',
							text: 'Items',
						},
					],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'itemCount',
							objectTable: 'warehouse',
						},
					],
					widthConfig: {
						mode: 'fixed',
						width: 100,
					},
					verticalAlignment: 'top',
				},
				{
					id: 'users-count',
					fields: [
						{
							id: 'users-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'userCount',
									objectTable: 'warehouse',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					headers: [
						{
							id: 'h6',
							text: 'Users',
						},
					],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'userCount',
							objectTable: 'warehouse',
						},
					],
					widthConfig: {
						mode: 'fixed',
						width: 100,
					},
					verticalAlignment: 'top',
				},
			],
			description:
				'Complete list of all warehouses with location and relationship information',
			defaultSortId: 'column-warehouse-name-asc',
			requiredFields: [
				'warehouse._id',
				'warehouse.name',
				'warehouse.externalId',
				'warehouse.address1',
				'warehouse.address2',
				'warehouse.city',
				'warehouse.state',
				'warehouse.zip',
				'warehouse.companyNames',
				'warehouse.clientCount',
				'warehouse.itemCount',
				'warehouse.userCount',
			],
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: ['warehouseKeywords', 'warehouseCompanies'],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/warehouses/:id',
			objectLabel: 'Warehouse',
			objectTable: 'warehouse',
			// Rows on this list are warehouse records keyed by `id`, so any
			// configured column of the table can be filled in server-side
			// (ListFieldHydrationService).
			rowIdField: 'id',
			selectedFields: [
				{
					fieldName: '_id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'name',
					fieldLabel: 'Name',
				},
				{
					fieldName: 'externalId',
					fieldLabel: 'External ID',
				},
				{
					fieldName: 'address1',
					fieldLabel: 'Address 1',
				},
				{
					fieldName: 'address2',
					fieldLabel: 'Address 2',
				},
				{
					fieldName: 'city',
					fieldLabel: 'City',
				},
				{
					fieldName: 'state',
					fieldLabel: 'State',
				},
				{
					fieldName: 'zip',
					fieldLabel: 'Zip',
				},
				{
					fieldName: '_created_date',
					fieldLabel: 'Created Date',
				},
			],
		},
	],
	tableSorts: [
		{
			id: 'name',
			name: 'Name',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'name',
					objectTable: 'warehouse',
				},
			],
			description: 'Sort warehouses by name',
		},
		{
			id: 'location',
			name: 'By Location',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'state',
					objectTable: 'warehouse',
				},
				{
					direction: 'ASC',
					fieldName: 'city',
					objectTable: 'warehouse',
				},
			],
			description: 'Sort by state then city',
		},
		{
			id: 'client-count',
			name: 'Most Clients',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'clientCount',
					objectTable: 'warehouse',
				},
			],
			description: 'Sort by number of clients',
		},
		{
			id: 'item-count',
			name: 'Most Items',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'itemCount',
					objectTable: 'warehouse',
				},
			],
			description: 'Sort by number of items',
		},
	],
};
